import axios from 'axios';
import format from 'date-fns/format';

const baseApiUrl = 'api/report';

const EX_TYPE_XLS = 'xlsx';
const EX_TYPE_PDF = 'pdf';
const EX_TYPE_CSV = 'csv';

export default class ReportService {
  public getSchedaFornitoreReport(supplierId: number, exportType: string, yearReport: number, evidDoc: number): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios({
        url: `${baseApiUrl}/scheda-fornitore?supplierId=${supplierId}&exportType=${exportType}&yearReport=${yearReport}+&evidDoc=${evidDoc}`,
        method: 'GET',
        responseType: 'blob' // important
      })
        .then(function(response) {
          if (!window.navigator.msSaveOrOpenBlob) {
            // BLOB NAVIGATOR
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'scheda_fornitore_' + supplierId + '_' + yearReport + '.' + exportType);
            document.body.appendChild(link);
            link.click();
          } else {
            // BLOB FOR EXPLORER 11
            const url = window.navigator.msSaveOrOpenBlob(
              new Blob([response.data]),
              'scheda_fornitore_' + supplierId + '_' + yearReport + '.' + exportType
            );
          }
          resolve('success');
        })
        .catch(err => {
          resolve('err: ' + err);
        });
    });
  }

  public exportUtenzeFornitori(query: any) {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/utenze-fornitori`, {
          params: {
            fromDate: query.fromDate + ' 00:00:00',
            toDate: query.toDate + ' 23:59:59',
            companyId: query.companyId
          },
          responseType: 'arraybuffer'
        })
        .then(response => {
          if (!window.navigator.msSaveOrOpenBlob) {
            let filename = response.headers.filename;

            // BLOB NAVIGATOR
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
          } else {
            let filename = response.headers.filename;
            // BLOB FOR EXPLORER 11
            const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename);
          }
          resolve('success');
        })
        .catch(err => {
          console.log(err);
        });
    });
  }

  public exportChecklistFornitori(query: any) {
    return new Promise<any>((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      let fromDate: any = query.fromDate + ' 00:00:00';
      let toDate: any = query.toDate + ' 23:59:59';
      let companyId = query.companyId;
      xhr.open('GET', baseApiUrl + `/checklist-fornitori?fromDate=${fromDate}&toDate=${toDate}&companyId=${companyId}`);
      xhr.setRequestHeader('Content-Type', 'application/json');
      const token = localStorage.getItem('jhi-authenticationToken') || sessionStorage.getItem('jhi-authenticationToken');
      xhr.setRequestHeader('Authorization', 'Bearer ' + token);
      xhr.responseType = 'blob';

      xhr.onload = function(e) {
        if (this.status == 200) {
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(this.response);
          const dateFormat = 'yyyyMMddHHmmss';
          const today = new Date();
          today.setDate(today.getDate());
          const date = new Date(
            today.getFullYear(),
            today.getMonth(),
            today.getDate(),
            today.getHours(),
            today.getMinutes(),
            today.getSeconds()
          );

          const todayFormated = format(date, dateFormat);
          link.download = 'ReportChecklistFornitori_' + todayFormated;
          link.click();
        } else {
          console.log('ERROR ', xhr.statusText);
        }
      };

      xhr.send();

      // axios
      //   .get(baseApiUrl + `/checklist-fornitori`, {
      //     params: {
      //       fromDate: query.fromDate + ' 00:00:00',
      //       toDate: query.toDate + ' 23:59:59',
      //       companyId: query.companyId
      //     },
      //     responseType: 'arraybuffer',
      //     timeout: 300000
      //   })
      //   .then(response => {
      //     if (!window.navigator.msSaveOrOpenBlob) {
      //       let filename = response.headers.filename;

      //       // BLOB NAVIGATOR
      //       const url = window.URL.createObjectURL(new Blob([response.data]));
      //       const link = document.createElement('a');
      //       link.href = url;
      //       link.setAttribute('download', filename);
      //       document.body.appendChild(link);
      //       link.click();
      //     } else {
      //       let filename = response.headers.filename;
      //       // BLOB FOR EXPLORER 11
      //       const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), filename);
      //     }
      //     resolve('success');
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    });
  }

  public exportSelfassesment(query: any) {
    return new Promise<any>((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      let questionId: any = query.questionId;
      let answerId: any = query.answerId;
      let checklistTplId = query.checklistTplId;
      let companyId = query.companyId;
      xhr.open(
        'GET',
        baseApiUrl +
          `/selfassesment-report?checklistTplId=${checklistTplId}&questionId=${questionId}&answerId=${answerId}&companyId=${companyId}`
      );
      xhr.setRequestHeader('Content-Type', 'application/json');
      const token = localStorage.getItem('jhi-authenticationToken') || sessionStorage.getItem('jhi-authenticationToken');
      xhr.setRequestHeader('Authorization', 'Bearer ' + token);
      xhr.responseType = 'blob';

      xhr.onload = function(e) {
        if (this.status == 200) {
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(this.response);

          link.download = 'fitchain_export_questions_' + questionId;
          link.click();
        } else {
          console.log('ERROR ', xhr.statusText);
        }
      };

      xhr.send();
    });
  }
}
